export default __webpack_public_path__ + "static/media/green-lock.fdc53e26.svg";